import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';

const Support = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="support-page">
      <Navigation 
        showDemoButton={false}
        secondaryButtonText="Back to Home"
        onSecondaryClick={() => navigate('/')}
        trackingLocation="support_page"
      />
      <div className="support-container">
        <div className="support-header">
          <h1>Product Support</h1>
          <p>We're here to help you make the most of Solidly Finance</p>
        </div>
        
        <div className="support-content">
          <div className="support-section">
            <h2>Get Help</h2>
            <p>
              Have questions about Solidly Finance? Our support team is ready to help you succeed.
            </p>
            
            <div className="contact-card">
              <h3>Contact Support</h3>
              <div className="contact-info">
                <div className="email-contact">
                  <strong>Email:</strong>
                  <a href="mailto:support@solidly.ai" className="support-email">
                    support@solidly.ai
                  </a>
                </div>
                <p className="response-time">
                  We typically respond within 24 hours during business days.
                </p>
              </div>
            </div>
          </div>
          
          <div className="support-section">
            <h2>Before You Contact Us</h2>
            <p>To help us assist you more quickly, please include:</p>
            <ul className="help-tips">
              <li>A clear description of the issue or question</li>
              <li>Steps you've already tried (if applicable)</li>
              <li>Your operating system (Windows, Mac, etc.)</li>
              <li>Any error messages you've encountered</li>
            </ul>
          </div>
        </div>
        
        <div className="back-to-home">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Support;